export default __webpack_public_path__ + "static/default-wp-image-85217e5ede104bf2a3e8f36faf27bb68.jpg";